import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

function ModalDeleteEvent({ show, onHide, data, submitClick }) {
  return (
    <>
      <Modal show={show} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title text-danger">Warning</h5>
        </ModalHeader>
        <ModalBody>
          <p>Are you sure want to delete this event ?</p>
        </ModalBody>
        <ModalFooter>
          <button onClick={() => submitClick(data)} type="button" className="btn btn-outline-danger">
            Delete
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalDeleteEvent;
